import { Injectable } from '@angular/core';
import { UserDataWorkingHourService } from './../data-services/user-data-working-hour.service'
import { UserOpeningHoursViewModel, UserShiftRequestModel } from './../business-entities/user-opening-view-model';
import { GenericResponse } from '../business-entities/generic-response';

@Injectable({
  providedIn: 'root'
})
export class UserWorkingHoursService {

  constructor(private userWorkingHourDataService: UserDataWorkingHourService) { }

  addEditSpecialOccasion(occasionalShiftSaveViewModel: any) {
    return this.userWorkingHourDataService.addEditSpecialOccasion(occasionalShiftSaveViewModel);
  }

  getSpecialOccasionList(userId: any) {
    return this.userWorkingHourDataService.getSpecialOccasionList(userId);
  }

  async getUserWorkingHoursDetails(receptionUserId: string, occasionId: number): Promise<UserOpeningHoursViewModel[]> {
    let returnValue: UserOpeningHoursViewModel[] = [];
    await this.userWorkingHourDataService.getUserWorkingHoursDetails(receptionUserId, occasionId).then((result) => {
      returnValue = result.responseObject;
    });
    return returnValue;
  }

  updateUserWorkingHours(dealerWorkingHours: UserShiftRequestModel): Promise<GenericResponse<any>> {
    return this.userWorkingHourDataService.updateUserWorkingHours(dealerWorkingHours);
  }

  getUserLunchShiftDetails(userId: string): Promise<GenericResponse<any>> {
    return this.userWorkingHourDataService.getUserLunchShiftDetails(userId);
  }

  deleteSpecialOccasion(occasionalShiftDeleteViewModel: any) {
    return this.userWorkingHourDataService.deleteSpecialOccasion(occasionalShiftDeleteViewModel);
  }

  addUserLeaves(userLeaves: any) {
    return this.userWorkingHourDataService.addUserLeaves(userLeaves);
  }

  getUserLeavesById(leaveId: number,userLeaveRecurringId:number) {
    return this.userWorkingHourDataService.getUserLeaves(leaveId,userLeaveRecurringId);
  }

  getUserLeaveList(receptionUserId:string){
    return this.userWorkingHourDataService.getUserLeavesList(receptionUserId);
  }

  updateUserLeave(userLeaves: any): Promise<GenericResponse<any>> {
    return this.userWorkingHourDataService.updateUserLeave(userLeaves);
  }

  deleteLeave(leaveId: number) {
    return this.userWorkingHourDataService.deleteLeave(leaveId);
  }
}
